import { render } from "./PresenterView.vue?vue&type=template&id=180b1069&scoped=true"
import script from "./PresenterView.vue?vue&type=script&lang=js"
export * from "./PresenterView.vue?vue&type=script&lang=js"

import "./PresenterView.vue?vue&type=style&index=0&id=180b1069&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180b1069"]])

export default __exports__